/* Hook encargado de grabar las "tasks" de la nota de venta

Autor: Benjamín León
Fecha: 2025-03-09
*/
import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'
import { SalenoteTasks } from '../interfaces/Salenote.ts'

import { makeUrlSalenoteTasksConfirm, makeUrlSalenoteTasksEdit } from './connectionData.tsx'

const useSalenotesTasksPoster = () => {
  const [errorSalenotesTasks, setErrorSalenotesTasks] = useState<Error | null>(null)
  const [errorSalenoteTasksConfirm, setErrorSalenoteTasksConfirm] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const salenotesTasksEdit = async (salenotes: SalenoteTasks[]) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlSalenoteTasksEdit()
      const res = await customPost<{ message: string }>(apiUrl, { salenotes: salenotes })
      setErrorSalenotesTasks(null)

      return res
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorSalenotesTasks(err)
      } else {
        setErrorSalenotesTasks(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }
  const salenoteTasksConfirm = async (salenote: SalenoteTasks, profile: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlSalenoteTasksConfirm()
      const res = await customPost<{ message: string }>(apiUrl, { salenote: salenote, profile: profile })
      setErrorSalenoteTasksConfirm(null)

      return res
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorSalenoteTasksConfirm(err)
      } else {
        setErrorSalenoteTasksConfirm(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return {
    errorSalenotesTasks,
    loading,
    salenotesTasksEdit,
    salenoteTasksConfirm,
    errorSalenoteTasksConfirm,
  }
}
export default useSalenotesTasksPoster
